var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-variant-component"},[_c('app-icon',{attrs:{"name":_vm.value === 'variant' ? 'layers' : 'hexagon'}}),_vm._v(" "),_c('span',{staticClass:"product-type text-capitalize"},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }